<style lang="less" scoped>
.list {position: relative;width: 350px;height: 240px;text-align: left;}
ul {list-style: none;height: 300px;overflow: hidden;}
span::before {content: "●";font-size: 12px;margin-right: 4px;vertical-align: top;}
li {margin-top: 15px;width: 350px;font-family: AlibabaPuHuiTi-Regular;font-size: 14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
span:hover {color: #13569e;}
span{letter-spacing: 1px;cursor: pointer;}
</style>

<!--何宽  2021.6.10
    该组件使用场景：将标题以列表的形式纵向展示，只展示8条数据，鼠标点击 标题，将 相应的对象 传递给父组件 -->
<template>
  <ul class="list">
    <li v-for="(item, index) in List" :key="index" @click="clickListNews(item)">
      <span v-if="index < 8"> {{ item.title }} </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['List'],
  data()
  {
    return {}
  },
  methods: {
    // 点击列表项，将选中的 列表对象 传递给父组件
    clickListNews(item)
    {
      this.$emit('clickListNews', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/List.vue